/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {fadeInOut as ɵa} from './lib/animations/fade-in-out.animation';
export {InsertionPointDirective as ɵb} from './lib/directives/insertion-point.directive';